jQuery(function() {
	initSlickCarousel();
});

function initSlickCarousel() {
	// Accessories carousel (if used elsewhere)
	jQuery('.accessories-carousel').slick({
		slidesToScroll: 1,
		slidesToShow: 1,
		rows: 0,
		arrows: true,
		dots: false,
		centerMode: true,
		centerPadding: '101px',
		focusOnSelect: false,
		prevArrow: '<button class="slick-prev"><i class="fa-light fa-long-arrow-left"></i></button>',
		nextArrow: '<button class="slick-next"><i class="fa-light fa-long-arrow-right"></i></button>',
		autoplaySpeed: 2500,
		mobileFirst: true,
		infinite: true,
		autoplay: false,
		speed: 700,
		responsive: [{
				breakpoint: 767,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					centerPadding: '101px'
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
                  centerPadding: '101px'
				}
			},
			{
				breakpoint: 375,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerPadding: '101px'
				}
			},
		],
	});

	// Our Work carousel
	const $ourWorkCarousel = jQuery('.our-work-carousel');
	const $prevBtn = jQuery('.slider-controls .slick-prev');
	const $nextBtn = jQuery('.slider-controls .slick-next');
	const $slideCount = jQuery('.slider-controls .slides-count');

	// Function to highlight correct slide based on screen width
	function highlightCorrectSlide(slick, currentSlide) {
		const $slides = $ourWorkCarousel.find('.slick-slide');
		$slides.removeClass('highlighted');

		let highlightIndex;

		// On mobile (below 768px), highlight the current (first visible) slide
		if (window.innerWidth < 768) {
			highlightIndex = currentSlide;
		} else {
			// On larger screens, highlight the second visible slide
			highlightIndex = currentSlide + 1;
		}

		$ourWorkCarousel
			.find(`.slick-slide[data-slick-index="${highlightIndex}"]`)
			.addClass('highlighted');
	}

	// On init
	$ourWorkCarousel.on('init', function(event, slick) {
		const totalSlides = slick.slideCount;
		const currentSlide = slick.currentSlide;
		$slideCount.text(`${String(currentSlide + 1).padStart(2, '0')}/${String(totalSlides).padStart(2, '0')}`);
		highlightCorrectSlide(slick, currentSlide);
	});

	// On after slide change
	$ourWorkCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		const totalSlides = slick.slideCount;
		$slideCount.text(`${String(nextSlide + 1).padStart(2, '0')}/${String(totalSlides).padStart(2, '0')}`);
		requestAnimationFrame(() => highlightCorrectSlide(slick, nextSlide));
	});

	// Initialize Slick
	$ourWorkCarousel.slick({
		slidesToScroll: 1,
		initialSlide: 0,
		infinite: true,
		speed: 700,
		arrows: true,
		dots: false,
		variableWidth: true,
		prevArrow: $prevBtn,
		nextArrow: $nextBtn,
		responsive: [{
			breakpoint: 768,
			settings: {
				slidesToShow: 1
			},
		}, ],
	});

	jQuery(window).on('load', function() {
		setTimeout(function() {
			jQuery('.our-work-carousel').slick('setPosition');
		}, 100);
	});
}